import React, { useEffect, useState } from 'react';
import { FaEye, FaEdit, FaPlus, FaSort, FaSortUp, FaSortDown, FaEnvelope } from 'react-icons/fa';
import ClientFormModal from './ClientFormModal';
import ClientViewModal from './ClientViewModal';
import Sidebar from './Sidebar';
import {  useNavigate } from 'react-router-dom';

const API_URL = '/api';

const ClientMaster = () => {
  const [clients, setClients] = useState([]);
  const [vendors, setVendors] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [showView, setShowView] = useState(false);
  const [selectedClient, setSelectedClient] = useState(null);
  const [isEdit, setIsEdit] = useState(false);
  const [sortConfig, setSortConfig] = useState({ key: null, direction: 'asc' });
  const [formLoading, setFormLoading] = useState(false);
  const navigate = useNavigate(); 
const [emailSendingId, setEmailSendingId] = useState(null);

  useEffect(() => {
    fetchClients();
    fetchVendors();
  }, []);

  const fetchClients = async () => {
    setLoading(true);
    try {
      const res = await fetch(`${API_URL}/clients`);
      const data = await res.json();
      setClients(data);
    } catch {
      setClients([]);
    }
    setLoading(false);
  };

  const fetchVendors = async () => {
    try {
      const res = await fetch(`${API_URL}/vendors`);
      const data = await res.json();
      setVendors(data);
    } catch {
      setVendors([]);
    }
  };
const handleResendEmail = async (client) => {
  setEmailSendingId(client.client_id); // Disable button

  try {
    const response = await fetch(`${API_URL}/clients/send-onboard-email`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        client_code: client.client_code
      })
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.message || 'Failed to send email');
    }

    alert('Onboarding email sent successfully!');
  } catch (error) {
    alert(error.message || 'Error sending email');
  } finally {
    setEmailSendingId(null); // Re-enable button
  }
};


  const handleSort = (key) => {
    let direction = 'asc';
    if (sortConfig.key === key && sortConfig.direction === 'asc') {
      direction = 'desc';
    }
    setSortConfig({ key, direction });
    const sortedClients = [...clients].sort((a, b) => {
      if (a[key] === null) return 1;
      if (b[key] === null) return -1;
      if (a[key] < b[key]) return direction === 'asc' ? -1 : 1;
      if (a[key] > b[key]) return direction === 'asc' ? 1 : -1;
      return 0;
    });
    setClients(sortedClients);
  };

  const getSortIcon = (key) => {
    if (sortConfig.key !== key) return <FaSort className="ml-1" />;
    return sortConfig.direction === 'asc' 
      ? <FaSortUp className="ml-1" /> 
      : <FaSortDown className="ml-1" />;
  };

  const handleView = async (client) => {
    try {
      const res = await fetch(`${API_URL}/clients/${client.client_id}`);
      if (res.ok) {
        const data = await res.json();
        setSelectedClient(data);
        setShowView(true);
      } else {
        setSelectedClient(client);
        setShowView(true);
      }
    } catch {
      setSelectedClient(client);
      setShowView(true);
    }
  };
  const handleEdit = (client) => {
    setSelectedClient(client);
    setIsEdit(true);
    setShowForm(true);
  };
  const handleCreate = () => {
    setSelectedClient(null);
    setIsEdit(false);
    setShowForm(true);
  };
  const handleFormSubmit = async (formData, isEditMode) => {
    setFormLoading(true);
    try {
      let response;
      if (isEditMode && selectedClient) {
        response = await fetch(`${API_URL}/clients/${selectedClient.client_id}`, {
          method: 'PUT',
          body: formData,
        });
      } else {
        response = await fetch(`${API_URL}/clients`, {
          method: 'POST',
          body: formData,
        });
      }
      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || 'Failed to save client');
      }
      setShowForm(false);
      fetchClients();
    } catch (error) {
      alert(error.message || 'An error occurred while saving the client');
    } finally {
      setFormLoading(false);
    }
  };
  const handleLogout = () => {
    navigate('/login');
  };


return (
  <div className="min-h-screen flex bg-[#E5E1DA]">
    {/* Sidebar */}
    <Sidebar onLogout={handleLogout} />

    {/* Main */}
    <main
      className="flex-1 p-2 md:p-6 overflow-hidden ml-0 md:ml-16 transition-all duration-300"
    >
      <div className="flex flex-col h-full">
        
        {/* Header */}
        <div className="flex flex-col sm:flex-row justify-center sm:justify-between items-center text-center lg:items-start items-center gap-3 mb-6">
          <h1 className="text-xl sm:text-2xl md:text-3xl font-bold text-[#2b6777]">
            Client Master
          </h1>
          <button
            className="flex items-center gap-2 bg-[#92C7CF] hover:bg-[#AAD7D9]  text-white font-semibold px-3 py-2 sm:px-4 sm:py-2 rounded-lg shadow transition text-sm sm:text-base"
            onClick={handleCreate}
          >
            <FaPlus /> Create New Client
          </button>
        </div>

        {/* Table Section */}
        <div className="flex-1 overflow-hidden">
          <div className="h-full overflow-auto scroll-smooth">
            <div className="overflow-x-auto ">
              <table className="w-full min-w-[700px] bg-white border-separate border-spacing-0">
                <thead>
                  <tr>
                    {[
                      { key: 'client_id', label: 'Client ID' },
                      { key: 'company_name', label: 'Company Name' },
                      { key: 'email_id', label: 'Email' },
                      { key: 'mobile_no', label: 'Mobile No.' },
                      { key: 'vendor_name', label: 'Vendor' },
                    ].map((col, idx) => (
                      <th
                        key={col.key}
                        className={`sticky top-0 z-20 bg-[#AAD7D9] text-[#2b6777] px-3 sm:px-6 py-3 sm:py-4 text-center border-r border-white text-xs sm:text-sm font-bold cursor-pointer hover:bg-[#92C7CF] transition-all duration-300 ${
                          idx === 0 ? '' : ''
                        }`}
                        onClick={() => handleSort(col.key)}
                      >
                        <div className="flex items-center justify-center">
                          {col.label} {getSortIcon(col.key)}
                        </div>
                      </th>
                    ))}
                    <th className="sticky top-0 z-20 bg-[#AAD7D9] text-[#2b6777] px-3 sm:px-6 py-3 sm:py-4 text-center text-xs sm:text-sm font-bold ">
                      Actions
                    </th>
                  </tr>
                </thead>

                <tbody>
                  {loading ? (
                    <tr>
                      <td colSpan={6} className="text-center py-8 text-[#AAD7D9] font-semibold text-sm sm:text-base">
                        Loading clients...
                      </td>
                    </tr>
                  ) : clients.length === 0 ? (
                    <tr>
                      <td colSpan={6} className="text-center py-8 text-[#AAD7D9] font-semibold text-sm sm:text-base">
                        No clients found.
                      </td>
                    </tr>
                  ) : (
                    clients.map((client) => (
                      <tr
                        key={client.client_id}
                        className="transition-all duration-300 group hover:bg-[#eaf6f6] hover:shadow-md border-b last:border-b-0 transform hover:scale-[1.01]"
                      >
                        <td className="px-3 sm:px-6 py-3 sm:py-4 text-center text-xs sm:text-sm font-mono whitespace-nowrap">
                          {client.client_code}
                        </td>
                        <td className="px-3 sm:px-6 py-3 sm:py-4 text-center text-xs sm:text-sm whitespace-nowrap font-semibold">
                          {client.company_name}
                        </td>
                        <td className="px-3 sm:px-6 py-3 sm:py-4 text-center text-xs sm:text-sm break-all max-w-[160px] sm:max-w-[180px]">
                          {client.email_id}
                        </td>
                        <td className="px-3 sm:px-6 py-3 sm:py-4 text-center text-xs sm:text-sm break-all max-w-[100px] sm:max-w-[120px]">
                          {client.mobile_no}
                        </td>
                        <td className="px-3 sm:px-6 py-3 sm:py-4 text-center text-xs sm:text-sm whitespace-nowrap">
                          {client.vendor_name || '-'}
                        </td>
                        <td className="px-3 sm:px-6 py-3 sm:py-4 flex gap-2 justify-center items-center">
                          <button
  title="Resend Onboard Email"
  disabled={emailSendingId === client.client_id}
  className={`p-2 rounded-full transition-all duration-200
    ${emailSendingId === client.client_id
      ? 'bg-gray-200 text-gray-400 cursor-not-allowed'
      : 'hover:bg-green-100 text-green-600 hover:scale-110'
    }`}
  onClick={() => handleResendEmail(client)}
>
  <FaEnvelope size={14} className="sm:size-4" />
</button>


                          <button
                            title="View"
                            className="p-2 rounded-full hover:bg-[#c8d8e4] text-[#2b6777] transition-all duration-200 hover:scale-110"
                            onClick={() => handleView(client)}
                          >
                            <FaEye size={14} className="sm:size-4" />
                          </button>
                          <button
                            title="Edit"
                            className="p-2 rounded-full hover:bg-[#c8d8e4] text-[#2b6777] transition-all duration-200 hover:scale-110"
                            onClick={() => handleEdit(client)}
                          >
                            <FaEdit size={14} className="sm:size-4" />
                          </button>
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>

        {/* Modals */}
        <ClientFormModal
          open={showForm}
          onClose={() => setShowForm(false)}
          onSubmit={handleFormSubmit}
          initialData={selectedClient}
          isEdit={isEdit}
          loading={formLoading}
          vendors={vendors}
        />
        <ClientViewModal
          open={showView}
          onClose={() => setShowView(false)}
          client={selectedClient}
        />
      </div>
    </main>
  </div>
);

};

export default ClientMaster; 